/**
 * 开放一些特别夸张的能力
 * 暴露this（通过this.globalModel可以访问全局数据）
 * 比如说eval
 */
import get from 'lodash/get';

const evalCode = {
    fn($event, code) {
        if (code) {
            // eslint-disable-next-line
            return eval(code);
        }
        return $event;
    },
    desc: '输入两个参数 $event, code，执行eval(b)，可以使用 this',
};

const getFormDataValueByPath = {
    fn($event, path) {
        return this.globalModel.getFormDataValueByPath(path);
    },
    desc: '输入两个参数 $event, path，返回全局数据中path对应值',
};

const getInitParamsValueByPath = {
    fn($event, path, defaultValue) {
        return get(this.globalModel.globalParams, path, defaultValue);
    },
    desc: '输入三个参数 $event, path, defaultValue ，返回全局附加数据中path对应值，若找不到则返回defaultValue',
};

const getRouteDataValueByPath = {
    fn($event, path, defaultValue) {
        return get(this.$route, path, defaultValue);
    },
    desc: '输入三个参数 $event, path, defaultValue ，返回 $route 中path对应值，若找不到则返回defaultValue',
};

const getGlobalFormDataValueByPath = {
    fn($event, path, defaultValue) {
        return get(this.globalModel.globalFormData, path, defaultValue);
    },
    desc: '输入三个参数 $event, path, defaultValue ，返回全局数据中path对应值，若找不到则返回defaultValue',
};

export default {
    evalCode,
    getFormDataValueByPath,
    getInitParamsValueByPath,
    getRouteDataValueByPath,
    getGlobalFormDataValueByPath,
};
